<template>
  <div class="page-comp-customer-partner-data">
    <jw-space class="partner-data-search">
      <span>{{ $t('查找数据') }}：</span>
      <jw-range-picker style="width: 300px" @change="onSelectTime" size="small" v-model="data.rangeDate" />
    </jw-space>
    <xl-table v-on="tPropsEvent" v-bind="tProps" ref="xlUserTable" :columns="columns">
      <!-- 编号插槽--详情 -->
      <template #salesNo="{ record }">
        <jw-link @click="salesServiceDetails(record)" v-if="record.salesNo">{{ record.salesNo }}</jw-link>
        <template v-else>-</template>
      </template>
      <!-- 客户名称插槽--详情 -->
      <template #customerId="{ record }">
        <jw-link @click="clientDetails(record)" v-if="record.customerId">{{ record.customerId?.label }}</jw-link>
        <template v-else>-</template>
      </template>
    </xl-table>
  </div>
</template>

<script setup>
import { inject, onMounted, reactive } from 'vue';
// import useLoading from '@/hooks/loading';
import { salesService } from '@/api/';
import useXlTable from '@/hooks/xl-table';
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
// const { loading } = useLoading(false); //loading
//表格
const { tProps, tPropsEvent, setTProps, setLoadListParams, loadTList } = useXlTable(salesService.getPartnerList.bind(salesService));
const data = reactive({
  salesId: inject('detailParams')?.id,
  rangeDate: [] //日期
});
const columns = [
  {
    title: t('数据日期'),
    dataIndex: 'dataDate',
    slotName: 'dataDate',
    width: 150,
    ellipsis: true,
    tooltip: true
  },
  {
    title: t('人均使用时长情况'),
    dataIndex: 'preUseTime',
    slotName: 'preUseTime',
    width: 180
  },
  {
    title: t('人均活跃情况'),
    dataIndex: 'perActiveRate',
    slotName: 'perActiveRate',
    width: 150
  },
  {
    title: t('CCM渗透情况'),
    dataIndex: 'ccmDeep',
    slotName: 'ccmDeep',
    width: 150
  },
  {
    title: t('审批渗透情况'),
    dataIndex: 'approvalDeepRate',
    slotName: 'approvalDeepRate',
    width: 150
  },
  {
    title: t('日历渗透情况'),
    dataIndex: 'calendarDeepRate',
    slotName: 'calendarDeepRate',
    width: 150
  },
  {
    title: t('IM渗透情况'),
    dataIndex: 'imDeepRate',
    slotName: 'imDeepRate',
    width: 150
  },
  {
    title: t('打卡渗透情况'),
    dataIndex: 'punchDeepRate',
    slotName: 'punchDeepRate',
    width: 150
  },
  {
    title: t('音视频会议渗透情况'),
    dataIndex: 'avDeepRate',
    slotName: 'avDeepRate',
    width: 180
  }
];
// 设置额外的props
setTProps({
  stickyHeader: 60
});
onMounted(() => {
  init();
});
const init = (params) => {
  if (params) {
    setLoadListParams({ salesId: data.salesId, beginDate: params?.[0] || undefined, endDate: params?.[1] || undefined });
  } else {
    data.rangeDate = []; // 重置时间
    setLoadListParams({ salesId: data.salesId, endDate: undefined, beginDate: undefined });
  }
  loadTList();
};
const onSelectTime = (v) => {
  console.log(101, v);
  data.rangeDate = v;
  init(v);
};
defineExpose({ init });
</script>
<style scoped lang="less">
@import './index.less';
</style>
